import { call } from "redux-saga/effects";

import { backOfficeApiService } from "../../../../actionService/apiService";
import { ApiCallResult } from "../../../../types";
import RateDto from "../../../../../dto/Rate/RateDto";

import endPoints from "./rates.endpoints";
import { RateHistoryRequestDto } from "./rates.requestsDto";

const backOfficeRatesApi = {
  getHistory: function* ({ rateId, ...dto }: RateHistoryRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Get], endPoints.history(rateId), undefined, dto)) as ApiCallResult<{
      data: Array<RateDto>;
      total: number;
    }>;
  },
};

export default backOfficeRatesApi;
